<template>
  <v-dialog :value="open" persistent max-width="560px">
    <v-card>
      <v-card-title>
        <span class="headline">Dodaj voucher do noty</span>
      </v-card-title>
      <v-card-text>
        <p class="mb-3" v-if="voucherNumber">
          Voucher: <strong>#{{ voucherNumber }}</strong>
        </p>
        <v-autocomplete
          :items="notes"
          v-model="selectedNoteId"
          label="Wybierz notę"
          item-value="id"
          item-text="number"
          :filter="() => true"
          :search-input.sync="noteSearch"
          v-validate="'required'"
          data-vv-name="nota"
          :error-messages="errors.collect('nota')"
          no-data-text="Wpisz numer lub odbiorcę aby wyszukać"
          browser-autocomplete="off"
        >
          <template slot="item" slot-scope="{ item }">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.number }} — {{ item.recipient_display || '—' }}</v-list-tile-title>
              <v-list-tile-sub-title>PLN {{ item.total_amount }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" flat @click="$emit('close')">Anuluj</v-btn>
        <v-btn color="blue darken-1" flat :disabled="processing" @click="onConfirm">Dodaj</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'AddVoucherToNote',
    props: {
      open: Boolean,
      voucherId: { type: Number, default: null },
      voucherNumber: { type: String, default: '' },
    },
    data() {
      return {
        selectedNoteId: null,
        noteSearch: null,
        noteSearchTimeout: null,
        notes: [],
        processing: false,
      };
    },
    watch: {
      open(val) {
        if (val) {
          this.reset();
          this.loadNotes('');
        }
      },
      noteSearch(val) {
        clearTimeout(this.noteSearchTimeout);
        this.noteSearchTimeout = setTimeout(() => {
          this.loadNotes(val || '');
        }, 300);
      },
    },
    methods: {
      ...mapActions('DebitNoteStore', ['searchNotes', 'attachVoucherToNote']),
      reset() {
        this.selectedNoteId = null;
        this.notes = [];
        this.$validator.errors.clear();
      },
      loadNotes(search) {
        this.searchNotes({ search, per_page: 20 })
          .then((response) => {
            this.notes = response.data || [];
          });
      },
      onConfirm() {
        this.$validator.validateAll()
          .then((valid) => {
            if (!valid) return;
            this.processing = true;
            this.attachVoucherToNote({ noteId: this.selectedNoteId, voucherId: this.voucherId })
              .then(() => {
                this.processing = false;
                this.$emit('attached');
              }, () => {
                this.processing = false;
              });
          });
      },
    },
  };
</script>
